import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

const Kansas = () => {
  const [showAllCities, setShowAllCities] = useState(false);

  useEffect(() => {
    // Set document title
    document.title = 'We Buy Valves Kansas | Industrial Equipment Buyers Kansas';
    
    // Set meta tags
    const metaTags = [
      { name: 'description', content: 'Professional valve buyers serving Kansas refineries and manufacturing facilities. We purchase surplus valves, Fisher control valves, and instrumentation at above scrap rates. Call 214-854-5638.' },
      { name: 'keywords', content: 'valve buyers Kansas, surplus valves, Fisher control valves, Kansas refineries, industrial equipment Kansas' },
      { property: 'og:title', content: 'We Buy Valves Kansas | Industrial Equipment Buyers Kansas' },
      { property: 'og:description', content: 'Professional valve buyers serving Kansas refineries and manufacturing facilities.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/kansas' },
      { property: 'og:type', content: 'website' }
    ];

    metaTags.forEach(tag => {
      const existingTag = document.querySelector(`meta[${tag.name ? 'name' : 'property'}="${tag.name || tag.property}"]`);
      if (existingTag) {
        existingTag.setAttribute('content', tag.content);
      } else {
        const meta = document.createElement('meta');
        if (tag.name) meta.setAttribute('name', tag.name);
        if (tag.property) meta.setAttribute('property', tag.property);
        meta.setAttribute('content', tag.content);
        document.head.appendChild(meta);
      }
    });

    // Set canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/kansas');

    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/kansas/#webpage",
          "url": "https://valvesalessupply.com/kansas",
          "name": "Kansas Industrial Equipment Buyers - ValveSalesSupply",
          "description": "Professional industrial equipment purchasing services throughout Kansas. Serving Wichita, Kansas City, and Topeka manufacturing facilities with above scrap market rates.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://valvesalessupply.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Service Areas",
                "item": "https://valvesalessupply.com/service-areas"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Kansas",
                "item": "https://valvesalessupply.com/kansas"
              }
            ]
          }
        },
        {
          "@type": "Place",
          "@id": "https://valvesalessupply.com/kansas/#place",
          "name": "Kansas",
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "KS",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 39.0119,
            "longitude": -98.4842
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply Kansas Operations",
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "KS",
            "addressCountry": "US"
          },
          "telephone": "+1-214-854-5638",
          "serviceArea": {
            "@type": "State",
            "name": "Kansas",
            "addressRegion": "KS"
          },
          "description": "Professional industrial equipment purchasing services throughout Kansas, serving manufacturing facilities, grain processing operations, and industrial plants in Wichita, Kansas City, Topeka, and surrounding areas."
        },
        {
          "@type": "ItemList",
          "name": "Kansas Cities We Serve",
          "numberOfItems": 3,
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "Place",
                "name": "Wichita",
                "url": "https://valvesalessupply.com/wichita"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "Place",
                "name": "Kansas City",
                "url": "https://valvesalessupply.com/kansas-city"
              }
            },
            {
              "@type": "ListItem",
              "position": 3,
              "item": {
                "@type": "Place",
                "name": "Topeka",
                "url": "https://valvesalessupply.com/topeka"
              }
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": faqData.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const kansasFacilities = [
    { name: 'McPherson', facilities: '2+ Refineries', response: '4-6 Hours' },
    { name: 'Coffeyville', facilities: '1+ Refinery', response: '5-7 Hours' },
    { name: 'El Dorado', facilities: '1+ Refinery', response: '5-7 Hours' },
    { name: 'Wichita', facilities: 'Processing Plants', response: '4-6 Hours' }
  ];

  const kansasCities = [
    'Abilene', 'Andover', 'Arkansas City', 'Atchison', 'Augusta', 'Baldwin City', 'Basehor', 'Bonner Springs',
    'Chanute', 'Coffeyville', 'Colby', 'Derby', 'Dodge City', 'El Dorado', 'Emporia', 'Garden City',
    'Gardner', 'Great Bend', 'Hays', 'Haysville', 'Hutchinson', 'Independence', 'Iola', 'Junction City',
    'Kansas City', 'Lansing', 'Lawrence', 'Leavenworth', 'Leawood', 'Lenexa', 'Liberal', 'Manhattan',
    'McPherson', 'Merriam', 'Mission', 'Newton', 'Olathe', 'Ottawa', 'Overland Park', 'Parsons',
    'Pittsburg', 'Prairie Village', 'Pratt', 'Roeland Park', 'Salina', 'Shawnee', 'Topeka', 'Ulysses',
    'Wellington', 'Wichita', 'Winfield'
  ];

  const faqData = [
    {
      question: "Do you buy valves from Kansas refineries?",
      answer: "Yes, we purchase surplus valves, Fisher control valves, and instrumentation from all Kansas refineries including McPherson, Coffeyville, and El Dorado facilities. We provide 4-6 hour response times with competitive pricing for Kansas industrial facilities."
    },
    {
      question: "What types of equipment do you buy in Kansas?",
      answer: "We buy control valves, ball valves, gate valves, butterfly valves, heat exchangers, pumps, compressors, safety systems, Rosemount transmitters, flow meters, pressure instruments, and controllers from Kansas refineries and manufacturing plants."
    },
    {
      question: "How quickly can you respond to Kansas facilities?",
      answer: "We provide 4-7 hour response times for Kansas facilities. Our team has 18+ years of experience serving Kansas refineries, grain processing operations, and manufacturing facilities throughout the state."
    },
    {
      question: "Do you purchase equipment from Kansas grain processing plants?",
      answer: "Yes, we buy process equipment and instrumentation from Kansas grain processing and agricultural facilities. We understand the specific requirements of food-grade and agricultural processing equipment."
    },
    {
      question: "What valve brands do you buy from Kansas facilities?",
      answer: "We purchase Fisher, Masoneilan, Flowserve, Cameron, Rosemount, Emerson, Honeywell, and other major brands from Kansas refineries, grain processing plants, and manufacturing facilities."
    },
    {
      question: "Do you serve all Kansas cities?",
      answer: "Yes, we serve all major Kansas cities including Wichita, Kansas City, Topeka, and surrounding areas. We provide fast response times and professional service throughout the entire state."
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/0f4bd1614d82a479b098b87983f576f9.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl font-bold mb-6">We Buy Valves Kansas</h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Professional surplus equipment buyer serving Kansas refineries and processing facilities. 
              We purchase valves, control systems, and instrumentation from McPherson, Coffeyville, 
              El Dorado, and throughout Kansas at above scrap rates.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:(214) 854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL (214) 854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET KANSAS QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Kansas Market */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">SURPLUS VALVE BUYER KANSAS</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Kansas hosts several important refineries and processing facilities that require professional 
                <strong className="text-[#1B3A5F]"> surplus equipment removal</strong> services during 
                turnarounds and facility upgrades.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                We provide <strong className="text-[#1B3A5F]">industrial equipment buying</strong> services 
                throughout Kansas, specializing in control valves, Fisher valves, Rosemount transmitters, 
                and complete control systems.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">5+</div>
                  <div className="text-gray-600">Kansas Facilities</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">4-7 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">18 Years</div>
                  <div className="text-gray-600">Kansas Experience</div>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">KANSAS SERVICE AREAS</h3>
              <div className="space-y-4">
                {kansasFacilities.map((facility, index) => (
                  <div key={index} className="flex justify-between items-center bg-white rounded-lg p-4">
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg">{facility.name}</h4>
                      <p className="text-gray-600 text-sm">{facility.facilities}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-[#1B3A5F] font-semibold">Response:</div>
                      <div className="text-gray-600 text-sm">{facility.response}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Kansas Cities Section */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">KANSAS CITIES WE SERVE</h2>
            <p className="text-gray-600 text-xl">Professional valve buying services across Kansas</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <Link
              to="/kansas-city"
              className="bg-white rounded-3xl p-8 hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-[#1B3A5F]"
            >
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-[#1B3A5F] text-2xl font-bold">Kansas City</h3>
                <i className="ri-arrow-right-line text-[#1B3A5F] text-2xl"></i>
              </div>
              <p className="text-gray-600 mb-4">
                Major manufacturing hub with 300+ industrial facilities. We buy valves from manufacturing plants, 
                food processing facilities, and chemical plants throughout the Kansas City metro area.
              </p>
              <div className="flex items-center text-[#1B3A5F] font-semibold">
                <i className="ri-map-pin-line mr-2"></i>
                4-6 Hour Response Time
              </div>
            </Link>

            <Link
              to="/topeka"
              className="bg-white rounded-3xl p-8 hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-[#1B3A5F]"
            >
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-[#1B3A5F] text-2xl font-bold">Topeka</h3>
                <i className="ri-arrow-right-line text-[#1B3A5F] text-2xl"></i>
              </div>
              <p className="text-gray-600 mb-4">
                Kansas capital with diverse industrial operations. We purchase surplus valves and instrumentation 
                from Topeka manufacturing plants, food processing facilities, and distribution centers.
              </p>
              <div className="flex items-center text-[#1B3A5F] font-semibold">
                <i className="ri-map-pin-line mr-2"></i>
                6-8 Hour Response Time
              </div>
            </Link>
          </div>

          <div className="text-center mt-12">
            <p className="text-gray-600 text-lg mb-6">
              We also serve <strong className="text-[#1B3A5F]">Wichita</strong>, McPherson, Coffeyville, El Dorado, 
              and all other Kansas industrial centers with professional valve buying services.
            </p>
          </div>
        </div>
      </section>

      {/* Equipment and Services */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY REFINERY EQUIPMENT KANSAS</h2>
            <p className="text-gray-600 text-xl">Professional equipment purchasing from Kansas industrial facilities</p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-3xl p-8 border-2 border-[#F5F7FA]">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">Control Valves</h3>
              <div className="space-y-3">
                {[
                  'Fisher Control Valves',
                  'Masoneilan Valves',
                  'Ball and Gate Valves',
                  'Globe and Butterfly Valves',
                  'Safety Relief Valves'
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="bg-white rounded-3xl p-8 border-2 border-[#F5F7FA]">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">Instrumentation</h3>
              <div className="space-y-3">
                {[
                  'Rosemount Transmitters',
                  'Flow Meters',
                  'Pressure Instruments',
                  'Temperature Sensors',
                  'Analytical Equipment'
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="bg-white rounded-3xl p-8 border-2 border-[#F5F7FA]">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">Control Systems</h3>
              <div className="space-y-3">
                {[
                  'DCS Control Systems',
                  'PLC Controllers',
                  'HMI Panels',
                  'Safety Instrumented Systems',
                  'Emergency Shutdown Systems'
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-16 bg-[#F5F7FA] rounded-3xl p-8">
            <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6 text-center">WHY SELL VALVES TO US IN KANSAS</h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                { icon: 'ri-money-dollar-circle-line', title: 'Above Scrap Rates', desc: 'Premium pricing for functional equipment' },
                { icon: 'ri-time-line', title: 'Fast Response', desc: '4-7 hour response throughout Kansas' },
                { icon: 'ri-shield-check-line', title: 'Full Documentation', desc: 'Complete regulatory compliance' },
                { icon: 'ri-truck-line', title: 'Professional Removal', desc: 'Expert equipment removal services' },
                { icon: 'ri-award-line', title: '18+ Years Experience', desc: 'Proven Kansas market expertise' },
                { icon: 'ri-customer-service-line', title: 'Direct Contact', desc: 'Work directly with Mark Driver' }
              ].map((benefit, index) => (
                <div key={index} className="flex items-start">
                  <i className={`${benefit.icon} text-[#1B3A5F] text-3xl mr-4`}></i>
                  <div>
                    <h4 className="text-[#1B3A5F] font-bold mb-1">{benefit.title}</h4>
                    <p className="text-gray-600 text-sm">{benefit.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-4xl font-bold mb-4">SELL SURPLUS VALVES KANSAS</h2>
            <p className="text-gray-200 text-xl">Professional valve buyers serving Kansas industrial facilities</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">KANSAS CONTACT</h3>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-phone-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold text-lg">(214) 854-5638</div>
                    <div className="text-gray-600">Kansas Direct Line</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold">valvesalessupply@gmail.com</div>
                    <div className="text-gray-600">Equipment Lists & Quotes</div>
                  </div>
                </div>
              </div>
              
              <Link
                to="/contact"
                className="w-full bg-[#1B3A5F] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#1B3A5F]/90 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET KANSAS QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
            
            <div className="text-white">
              <h3 className="text-3xl font-bold mb-6">KANSAS ADVANTAGES</h3>
              <div className="space-y-4">
                {[
                  'Above scrap rates for functional equipment',
                  'Fast response to Kansas facilities',
                  'Professional turnaround coordination',
                  'Complete regulatory documentation',
                  '18+ years Kansas market experience',
                  'Emergency equipment removal support'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-white text-xl mr-4"></i>
                    <span className="text-lg">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Kansas Cities Dropdown - Above FAQ */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY SURPLUS VALVES IN ALL KANSAS CITIES</h2>
            <p className="text-gray-600 text-xl mb-8">Professional valve buying services across Kansas - Click to view all cities</p>
          </div>

          <div className="bg-[#F5F7FA] rounded-3xl p-8 mb-8">
            <div className="grid md:grid-cols-3 gap-6 mb-6">
              <div className="text-center">
                <div className="text-[#1B3A5F] text-3xl font-bold mb-2">50+</div>
                <div className="text-gray-600">Kansas Cities Served</div>
              </div>
              <div className="text-center">
                <div className="text-[#1B3A5F] text-3xl font-bold mb-2">4-8 Hours</div>
                <div className="text-gray-600">Average Response Time</div>
              </div>
              <div className="text-center">
                <div className="text-[#1B3A5F] text-3xl font-bold mb-2">Same Day</div>
                <div className="text-gray-600">Equipment Removal Available</div>
              </div>
            </div>
          </div>

          <button
            onClick={() => setShowAllCities(!showAllCities)}
            className="w-full bg-[#1B3A5F] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#1B3A5F]/90 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap mb-8"
          >
            {showAllCities ? 'HIDE KANSAS CITIES' : 'VIEW ALL KANSAS CITIES'}
            <i className={`${showAllCities ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} ml-2 text-2xl`}></i>
          </button>

          {showAllCities && (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 animate-fadeIn">
              {kansasCities.map((city, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg p-4 border-2 border-[#F5F7FA] hover:border-[#1B3A5F] hover:shadow-lg transition-all duration-300 cursor-pointer"
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-[#1B3A5F] font-bold text-lg mb-1">{city}</h3>
                      <p className="text-gray-600 text-sm">We Buy Valves {city} KS</p>
                    </div>
                    <i className="ri-map-pin-line text-[#1B3A5F] text-xl"></i>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-[#1B3A5F] text-4xl font-bold mb-12 text-center">KANSAS VALVE BUYERS FAQ</h2>
          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-xl p-6">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-3">{faq.question}</h3>
                <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Kansas;
